import axios from "axios";
import apiConfig from "../config/api.config";
import { message } from "antd";
import rootIndex from "../store/root_index";
import CryptoJS from "crypto-js";
const { store } = rootIndex;
const { baseURL, auth, secure, NODE_ENV } = apiConfig;

// it will execute the request
// common function for all methods
const ExecRequest = (config, options = { secure: true, multipart: false }, hashedOptions) => {
  const _store = store.getState();
  let userSignature = null,
    userRequestId = null;

  userSignature = hashedOptions?.Signature === undefined || hashedOptions?.Signature === null || hashedOptions?.Signature === "" ? null : hashedOptions?.Signature;
  userRequestId = hashedOptions?.requestId === undefined || hashedOptions?.requestId === null || hashedOptions?.requestId === "" ? null : hashedOptions?.requestId;

  function promiseCallback(resolve) {
    let headers = {
      "Content-Type": options.multipart ? "multipart/form-data" : "application/json",
    };
    headers = options.secure
      ? {
          ...headers,
          authorization: "Bearer " + _store.login.token,
          Signature: userSignature,
          RequestId: userRequestId,
        }
      : headers;
    config.url = `${baseURL}${options.secure ? secure : auth}${config.url}`;

    ////console.log(config.url,"configg")

    axios({ ...config, headers: headers })
      .then((res) => {
        // console.log("Response on axios", res);
        if (res.status === 200) {
          const serverSignature = res?.data?.signature;
          const responseData = res?.data;
          const clientRequestId = res?.config?.headers?.RequestId;

          let validResponse = checkValidResponse(serverSignature, responseData, clientRequestId);

          if (validResponse) {
            const errCode = res.data.errCode;
            const data = res.data;
            if (errCode === -1) {
              if (typeof data?.errMsg?.txt === "string") {
                message.success(data?.errMsg?.txt);
              }
              if (typeof data.errMsg === "string") {
                // alert(data.errMsg)
                message.success(data.errMsg || data?.errMsg?.Message || data?.errMsg?.msg);
              } else {
                // console.warn('API___URL____',config)
                // alert('Your request has been resolved successfully');
                if (config.method === "post") {
                  // console.warn('API___URL____',config.url.hasOwnProperty('todo_task'))
                  if (config.url.includes("todo_task")) message.success("Todo Created successfully");
                  if (config.url.includes("bookAppointment")) message.success("Event Created successfully");
                  if (config.url.includes("addlead")) message.success("Lead Created successfully");
                  if (config.url.includes("addProposal")) message.success("Benefit Illustration Form Generated Successfully");
                  if (config.url.includes("sendOtpAuthentication")) message.success("Review link created");
                  if (config.url.includes("iibResponse")) message.success("IIB Triggered Successfully");

                } else if (config.method === "put") {
                  if (config.url.includes("update_task_status")) message.success("Todo Updated successfully");
                  if (config.url.includes("updateAppointment")) message.success("Event Updated successfully");
                  // Don't show default message for updateLeadV2 (handled in component)
                  if (config.url.includes("updateLead") && !config.url.includes("updateLeadV2")) message.success("Lead Updated successfully");
                  if (config.url.includes("updateProposal")) message.success("Proposal Updated successfully");
                  // message.success("Details Updated successfully");
                }
                // if (config.method !== "get") message.success("Your data fetched successfully");
                // if (config.method === "put") message.success("Data updated successfully");
              }
              resolve(data.errMsg);
            } else if (errCode == 4) {
              // console.log("CHECKENIN", data);
              //console.log("CHECKENIN",typeof(data.errMsg));

              if (typeof data.errMsg === "object") {
                if (config.url.includes("fetchMobileToBank")) {
                  message.error("No Bank details found from mobile number. Please fill your details");
                }
                else {
                  const msg = data?.errMsg?.Message || data?.errMsg?.txt || data?.errMsg?.msg || data?.errMsg?.errMsg;
                  if (msg) {
                    message.warning(msg);
                  }
                }

              } else if (config.url.includes("generate-aadhaar-otp")) {
                message.error("Something went wrong, please try again.");
              } else if (config.url.includes("submit-aadhaar-otp")) {
                message.warning("Invalid details, could not verify");
              } else if (data?.errMsg) {
                const msg = typeof data.errMsg === 'string' ? data.errMsg : data.errMsg?.Message || data.errMsg?.txt || data.errMsg?.msg || data.errMsg?.errMsg;
                if (msg) {
                  message.warning(msg);
                }
              } else {
                message.warning("An error occurred");
              }
              resolve(data);
              return;
            } else if (errCode === 25) {
              message.warning(data?.errMsg || data?.errMsg?.Message || data?.errMsg?.msg);
              resolve(data);
            } else if (data?.errCode === 9) {
              //console.log("data",data)
              resolve(data);
            } else if (errCode === 1) {
              //console.log("Typeof" , typeof(data?.errMsg));
              //console.log("Typeof" , data?.errMsg);
              if (typeof data?.errMsg?.txt === "string") {
                message.error(data?.errMsg?.txt);
                resolve(data);
              }
              if (data?.errMsg?.status == 402 || data?.errMsg?.status == 504) {
                // message.warning(data?.errMsg?.error);
                let err = data;
                resolve(err);
                return;
              } else if (data?.errMsg?.statusCode === 102) {
                // message.error("Please Enter Correct Aadhar Card Number");
                resolve(data);
                return;
              } else if (data?.errMsg?.status === 503) {
                message.error("No response received, please try after some time");
                resolve(data);
                return;
              } else if (Array.isArray(data?.errMsg)) {
                const errormessageValue = data?.errMsg?.map((errormsg) => {
                  return errormsg.value;
                });
                // message.error(errormessageValue);
                resolve(data);
                return;
              } else if (typeof data?.errMsg == "object") {
                // const errormessageValue = data?.errMsg?.map((errormsg) => {
                //   console.log("errMSG---->",errormsg)
                //   return errormsg.value;
                // });
                // console.log("errMSG---->", data);
                // message.error(errormessageValue);   // uncomment if any effects in errMSG
                resolve(data);
                return;
              } else {
                const finalMsg = typeof data?.errMsg === 'string' ? data.errMsg : data?.errMsg?.Message || data?.errMsg?.msg || data?.errMsg?.error || "An error occurred";
                message.warning(finalMsg);
                let err = data;
                resolve(err);
                return;
              }
            } else if (errCode === 12544) {
              message.warning(data?.errMsg);
            } else if (errCode === 121) {
              message.warning(data?.errMsg || data?.errMsg?.Message || data?.errMsg?.msg);
              resolve(data);
            } else if (data?.errCode === 10201) {
              message.warning(data?.errMsg || data?.errMsg?.Message || data?.errMsg?.msg);
              resolve(data);
              //console.log("data",data);
            } else if (errCode === 2601) {
              resolve(data.errMsg);
              message.warning(data?.errMsg || data?.errMsg?.Message || data?.errMsg?.msg);
            } else if (errCode == 529) {
              resolve(data);
              message.warning(data?.errMsg || data?.errMsg?.Message || data?.errMsg?.msg);
            } else if (errCode == 256) {
              message.error(data.errMsg);
              resolve(data);
              return;
            } else if (errCode == 539) {
              // window.location.replace("/login");
              resolve(data);
            } else {
              // alert(data.errMsg);
              if (config.method !== "get") {
                message.error(data.errMsg || data?.errMsg?.Message || data?.errMsg?.msg);
              }
              // message.error(data.errMsg);
              resolve(null);
            }
          } else {
            return message.error("Something went wrong. Please try again");
          }
        } else {
          resolve(null);
          return message.error("Network error. Please try again");
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
          const apiData = error.response.data;
          const apiErrMsg = apiData?.errMsg;
          const msgToShow = typeof apiErrMsg === "string" ? apiErrMsg : apiErrMsg?.message || apiErrMsg?.Message || apiErrMsg?.txt || apiData?.Message || "An error occurred";

          if (error.response.status === 400 || error.response.status === 401) {
            try {
              if (apiData.errCode === 81) {
                // for validation error purpos
              } else if (apiData.errCode === 23) {
                resolve(apiData);
              } else if (apiData.errCode === 1) {
                resolve(apiData);
              }
              else if (apiData.errCode === 25) {
                localStorage.clear();
                window.location.replace("/login");
              }
            } catch (error) {
              console.error("Error in error handling", error);
            }
          } else if (error?.response?.status === 500 || error?.response?.status === 504) {
            try {
              if (error?.response?.data?.errCode == 4) {
                resolve(error?.response?.data?.errMsg);
              }
            } catch (error) {
            }
          }
        } else if (error.request) {
          message.error("Request failed");
        } else {
          console.error(error);
          message.error(`${error.name}: ${error.message}`);
        }
        resolve(null);
      });
  }
  return new Promise(promiseCallback);
};

const checkValidResponse = (serverSignature, responseData, clientRequestId) => {
  // console.log("check sign", serverSignature);

  let responseToHash = responseData;
  delete responseToHash?.signature;
  // console.log("final response to hash", responseToHash);

  let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA512, process.env.REACT_APP_ENCRYPTION_PRIVATE_KEY);
  hmac.update(JSON.stringify(responseToHash));
  const hash = hmac.finalize().toString(CryptoJS.enc.HEX);

  // console.log("check hash", hash);

  if (serverSignature) {
    if (serverSignature === hash) {
      // check request id
      if (clientRequestId) {
        if (clientRequestId === responseToHash?.requestId) {
          return true;
        } else {
          message.error("Invalid Signature");
          return false;
        }
      } else {
        return true;
      }
    } else {
      message.error("Invalid Signature");
      return false;
    }
  } else {
    return true;
  }
};

export default {
  get: async (endPoint, options = { secure: true, multipart: false }) => {
    options = options.multipart
      ? options
      : {
        ...options,
        multipart: false,
      };
    let result = await ExecRequest(
      {
        method: "get",
        url: endPoint,
      },
      options
    );

    return !result ? [] : result;
  },
  post: async (endPoint, dataBody, options = { secure: true, multipart: false }, hashedOptions) => {
    options = options.multipart
      ? options
      : {
        ...options,
        multipart: false,
      };
    let result = await ExecRequest(
      {
        method: "post",
        url: endPoint,
        data: dataBody,
      },
      options,
      hashedOptions
    );

    return !result ? [] : result;
  },
  put: async (endPoint, dataBody, options = { secure: true, multipart: false }) => {
    options = options.multipart
      ? options
      : {
        ...options,
        multipart: false,
      };
    //console.log("endPoint here====>",endPoint)
    if (endPoint == undefined || endPoint == null) {
      return "No end point";
    } else {
      let result = await ExecRequest(
        {
          method: "put",
          url: endPoint,
          data: dataBody,
        },
        options
      );
      return !result ? [] : result;
    }
  },
};
